// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".last-topic_box{margin-left:40px}.last-topic_box .el-input--mini,.last-topic_box span{margin-left:10px}", ""]);
// Exports
module.exports = exports;
